export default {
  Canvas: {
    CanvasWidth: 1500,
    CanvasHeight: 300,
    CanvasBorderWeight: 0,
    CanvasBorderColor: '#bcbcbc',
    CanvasFillColor: '#fff',
    CanvasOpacity: 1,

    CanvasChartX: 0,
    CanvasChartY: 0,
    CanvasChartWidth: 1300,
    CanvasChartHeight: 760,
    CanvasChartBorderWeight: 0,
    CanvasChartBorderColor: '#757575',
    CanvasChartFillColor: '#fff',
    CanvasChartOpacity: 1,
    CanvasChartSpace: 0,

    CanvasFontFamily: 'roboto',
  },
  
  Text: {
    Text: [],
    Filter: [],
    Sql: []
  },

  // --> this.rawData
  DataItems: [ 
    {
      COUNT: 3,
      TEXT1: 'Total',
      TEXT2: 'Issued$',
      TEXT3: 'Remain$',
      
      COLOR1: '#757575',
      COLOR2: '#757575',
      COLOR3: '#F35E90',

      VALUE1: 1111,
      VALUE2: 2222,
      VALUE3: 3333,

      LINK1: 'Y',
      LINK2: 'Y',
      LINK3: 'N',

      FILTER1: 'filter1',
      FILTER2: 'filter2',
      FILTER3: 'filter3',
    }
  ],

  Queries: {
    // --> this.style
    SQL1:  [
      {
        // TABLE
        BOX_WIDTH: 150,
        BOX_HEIGHT: 30,
        BOX_PADDING: 5,
        BOX_FILL_COLOR: 'Transparent',
        BOX_STROKE_COLOR: '#BCBCBC',
        BOX_STROKE_SIZE: 1,
        BOX_OPACITY: 0.5,
        BOX_RADIUS: 5,
        
        COL_V_PADDING: 3,
        COL_TEXT_COLOR: '#757575',
        COL_TEXT_SIZE: 10,
        COL_TEXT_WEIGHT: 400,

        VALUE_TEXT_SIZE: 13,
        VALUE_TEXT_WEIGHT: 500,
      },
    ],
  },
}